import ReactGA from 'react-ga';

import config from '../data/config';

ReactGA.initialize(config.ga.id, {
  debug: config.ga.debug,
});

ReactGA.pageview(window.location.pathname + window.location.hash);
